import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [schema, setSchema] = useState('');
  const [loginResult, setLoginResult] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=login&schema=${encodeURIComponent(schema)}&tuser=${username}&tpass=${password}`
      );
      const data = await response.json();
      if (data[0].TUSERNAME !== "SALAH") {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('nama_user', data[0].TUSERNAME); 
        localStorage.setItem('id_user', data[0].ID_USER);         
        localStorage.setItem('is_admin', data[0].IS_ADMIN);  
        localStorage.setItem('po_access', data[0].PO);
        localStorage.setItem('do_access', data[0].DO);
        localStorage.setItem('ts_access', data[0].TS);
        localStorage.setItem('bk_access', data[0].BK);
        localStorage.setItem('hk_access', data[0].HK);
        localStorage.setItem('mobilfree_access', data[0].MOBILFREE);
        localStorage.setItem('lap_hk_access', data[0].LAP_HK);
        localStorage.setItem('lap_sj_access', data[0].LAP_SJ);
        localStorage.setItem('LastPosition', data[0].LASTPOSITION);
        localStorage.setItem('lap_daily', data[0].IS_ADMIN);         
        localStorage.setItem('lap_mg_access', data[0].LAP_MG);
        localStorage.setItem('lap_jbm_access', data[0].LAP_JBM);
        localStorage.setItem('mi_access', data[0].MI);    
        localStorage.setItem('lap_kinerja_access', data[0].LAP_KINERJA);    
        localStorage.setItem('schema', schema);
        navigate('/dashboard', { state: { tusername: data[0].TUSERNAME } });
      } else {
        setLoginResult('Login failed, incorrect credentials');
      }
    } catch (error) {
      console.error('Error:', error);
      setLoginResult('Login failed, please try again later');
    }
  };

  return (
    <div className="App">
      <h2>Login</h2>
      <form>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="text"
          placeholder="server"
          value={schema}
          onChange={(e) => setSchema(e.target.value)}
        />

        <button type="button" onClick={handleLogin}>Login</button>
      </form>
      {loginResult && <p className="error">{loginResult}</p>}
    </div>
  );
}

export default LoginPage;
